// extracted by mini-css-extract-plugin
export default {"cls1":"MzpKJV1NDGWhDSs0R2lO","cls2":"r_gNTj3eDibXrvgj6gS9 MzpKJV1NDGWhDSs0R2lO"};